import { convertGeneralToCircle } from './generators/generateCircleData';

export function detectEquationType(input) {
  const clean = input.replace(/\s+/g, '');
  if (/^x\s*=/.test(clean)) return 'vertical-line';
  if (/^([a-zA-Z]\(x\)|y)\s*=/.test(clean)) return 'function';
  if (/^[+-]?[\d.]*x[+-][\d.]*y[+-]?[\d.]*=0$/.test(clean)) return 'general-line';
  if (/^\(x[+-]\d+(\.\d+)?\)\^2\+\(y[+-]\d+(\.\d+)?\)\^2=\d+(\.\d+)?$/.test(clean)) return 'circle';
  if (/^x\^2\+y\^2=\d+(\.\d+)?$/.test(clean)) return 'circle';
  if (convertGeneralToCircle(input)) return 'circle-general';
  return 'unknown';
}
